import { MedplumClient } from '@medplum/core';
import posthog from 'posthog-js';

import { env } from './env';

/**
 * Singleton MedplumClient instance for FHIR API interactions
 *
 * MedplumClient automatically handles session persistence in localStorage.
 * On initialization, it will restore any existing session automatically.
 *
 * Configured with:
 * - baseUrl: Medplum backend API endpoint
 * - clientId: OAuth2 client ID for authentication
 * - onUnauthenticated: Redirect to sign-in when token expires
 */
let redirectPending = false;

export const medplum = new MedplumClient({
  baseUrl: env.VITE_MEDPLUM_BASE_URL,
  clientId: env.VITE_MEDPLUM_CLIENT_ID,
  cacheTime: 0,
  onUnauthenticated: () => {
    if (import.meta.env.VITE_MOCK_API === 'true') return;
    if (window.location.pathname === '/') return;

    if (!redirectPending) {
      redirectPending = true;
      posthog.reset();
      window.location.href = '/';
    }
  },
});
